var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"m-table m-table-head",class:{
    'm-table__border': _vm.border
  },style:({
    width: _vm.width
  })},[_c('colgroup',[_vm._l((_vm.columns),function(column,index){return _c('col',{key:column.label + index,attrs:{"width":column.width}})}),_vm._v(" "),(_vm.hasGutter)?_c('col',{attrs:{"name":"gutter","width":_vm.gutterWidth}}):_vm._e()],2),_vm._v(" "),_c('thead',{ref:"thead"},[_vm._l((_vm.columns),function(column,index){return _c('th',{key:column.label + index,staticClass:"m-table-column",class:_vm.cellClass(column, index),style:({
        width: column.width,
        height: _vm.headHeight
      }),attrs:{"colspan":"1","rowspan":"1"},on:{"mousemove":_vm.thMouseMove,"mousedown":function($event){_vm.thMouseDown($event, index)}}},[_vm._v(_vm._s(column.label))])}),_vm._v(" "),(_vm.hasGutter)?_c('th',{staticClass:"gutter"}):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-248d5a20","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/table-header.vue
// module id = null
// module chunks = 